module.exports = __webpack_public_path__ + "img/Gr5.754e69f1.png";